/* eslint-disable no-unused-vars */
import { Box, Button, ButtonGroup, Text, Tooltip, VisuallyHidden } from '@chakra-ui/react'
import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { TRCIcon } from './Icons'
import { useNavigate, useLocation } from 'react-router-dom';

function handleLogin(instance, navigate, from) {
    instance.loginPopup(loginRequest).then(() => { navigate(from, { replace: true }); }).catch(e => {
        console.error(e);
    });
}

export const OAuthButton = () => {
    let navigate = useNavigate();
    let location = useLocation();
    let from = `${location.state?.from?.pathname}${location.state?.from?.search}` || "/";
    const { instance } = useMsal();
    return (
        <ButtonGroup bg="base.900" variant="outline" spacing="4" width="full">
            <Tooltip label="Sign in using TRC credentials.">
                <Button key="trcButton"
                    onClick={() => handleLogin(instance, navigate, from)}>
                    <Box padding="2" margin="2"><Text>Signin with </Text></Box><TRCIcon boxSize="20" />
                    <VisuallyHidden>Sign in with your TRC Credentials</VisuallyHidden>
                </Button>
            </Tooltip>
        </ButtonGroup>
    )
}
